import { Button, FixedInfoBanner } from '@kanda-libs/ks-design-library';
import { useMemo } from 'react';
import useGhostBanner from './useGhostBanner';

const GhostBanner: React.FunctionComponent = function () {
  const { name, email, visible } = useGhostBanner();

  const label = useMemo(() => {
    if (!name) return `You are currently logged in as ${email}.`;
    return `You are currently logged in as ${name} (${email}).`;
  }, [name, email]);

  return (
    <FixedInfoBanner visible={visible} variant="orange">
      <div className="flex flex-row flex-1 justify-between items-center gap-x-4">
        <p className="text-16-20 text-neutral-000">{label}</p>
        <a href="/">
          <Button.Text
            id="howdens-ghost-banner-switch"
            label="Return to account"
            variant="danger"
            size={40}
          />
        </a>
      </div>
    </FixedInfoBanner>
  );
};

export default GhostBanner;
